export default "__VITE_ASSET__cd2543b2__"